// Metro from NPM
import '@olton/metroui/lib/metro.js';
// Metro 5.1.3
// import '../metro5.1.3/metro.js';

// DropZone
import Dropzone from 'dropzone';
import "dropzone/dist/dropzone.css";
window.Dropzone = Dropzone;

// Chart.js
import { Chart, registerables } from 'chart.js';
import 'chartjs-adapter-date-fns';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(...registerables, ChartDataLabels);
window.Chart = Chart;

// EasyMDE
import EasyMDE from 'easymde';
import 'easymde/dist/easymde.min.css';
window.EasyMDE = EasyMDE;

window.editors = {};
document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll('.easymde').forEach(function (textarea) {
	    const instance = new EasyMDE({
	        element: textarea,
	        minHeight: "200px",
	        maxHeight: "200px",
	        status: false,
	        spellChecker: false,
			toggleFullscreen: false,
			sideBySideFullscreen: false,
	    });
        // Stocke l'instance par id pour un accès futur
        if (textarea.id) {
            editors[textarea.id] = instance;
        }
	});
});

// Chart colors
window.chartColors = {
	red: 'rgb(255, 99, 132)',
	orange: 'rgb(255, 159, 64)',
	yellow: 'rgb(255, 205, 86)',
	green: 'rgb(75, 192, 192)',
	blue: 'rgb(54, 162, 235)',
	purple: 'rgb(153, 102, 255)',
	grey: 'rgb(201, 203, 207)'
};

// Maximize the font contrast of the text with the given background color
function getContrastColor(hexColor) {
    // Convertit #rrggbb en composantes 0-255
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    // Linéarisation sRGB (WCAG 2.1)
    const toLinear = c => {
        const s = c / 255;
        return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    };

    const L = 0.2126 * toLinear(r)
        + 0.7152 * toLinear(g)
        + 0.0722 * toLinear(b);

    return L > 0.8 ? '#2d2d2d' : '#ffffff';
    // return L > 0.179 ? '#000000' : '#ffffff';
}

window.getContrastColor = getContrastColor;
